import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from "./authinterceptor";
import AuthHeader from "../services/auth.header";

export const getCatalog = createAsyncThunk('catalog/getCatalog', async (categoryParams) => {
    try {
        let config = {
          headers: AuthHeader.authHeader(),
          params: {
            range: JSON.stringify([categoryParams[1], categoryParams[2]]),
            categoryId: categoryParams[0],
            priceFilter: categoryParams[3]
          },
        }

        const response = await axios.get(process.env.REACT_APP_API_URL + "/catalog", config );
        console.log("CATALOG RESPONSE" , response.data);
        for(var i=0; i<response.data.data.length; i++) {
          // Print items don't have colors - skip JSON parsing for them
          if (response.data.data[i].isPrintItem) {
            continue;
          }
          console.log("CATALOG RESPONSE" , i, response.data.data[i].colors);
          response.data.data[i].colors = JSON.parse(response.data.data[i].colors);
        }
        console.log("CATALOG RESPONSE2" , response);
        return response.data;
    } catch (error) {
        console.log(error);
    }
  });

  export const getIgniteProducts = createAsyncThunk('catalog/getIgniteProducts', async (params = {}) => {
    try {
        const page = params.page || (Array.isArray(params.range) ? params.range[0] : 1) || 1;
        const perPage = params.perPage || (Array.isArray(params.range) ? params.range[1] : 24) || 24;
        const search = params.search || '';
        const categoryId = params.categoryId || 'all';
        const productType = params.productType || 'all';

        let config = {
          headers: AuthHeader.authHeader(),
          params: {
            range: JSON.stringify([page, perPage])
          }
        };
        if (search && String(search).trim() !== '') {
          config.params.search = String(search).trim();
        }
        if (categoryId && categoryId !== 'all') {
          config.params.categoryId = categoryId;
        }
        if (productType && productType !== 'all') {
          config.params.productType = productType;
        }

        const response = await axios.get(process.env.REACT_APP_API_URL + "/admin/igniteproducts", config);
        const rows = response.data?.data || [];
        for (var i = 0; i < rows.length; i++) {
          if (typeof rows[i].colors === 'string') {
            try {
              rows[i].colors = JSON.parse(rows[i].colors);
            } catch (e) {
              rows[i].colors = [];
            }
          }
        }
        const count = response.data?.count != null
          ? response.data.count
          : (response.headers["total-items"] || rows.length);
        return { data: rows, count: parseInt(count, 10) || 0 };
    } catch (error) {
        console.log(error);
        throw error;
    }
  });

  export const getAdminCatalog = createAsyncThunk('catalog/getAdminCatalog', async (categoryParams) => {
    try {
        let config = {
          headers: AuthHeader.authHeader(),
          params: {
            range: JSON.stringify([categoryParams[1], categoryParams[2]])
          },
        }
      
        const response = await axios.get(process.env.REACT_APP_API_URL + "/admin/allcatalog/category/" + categoryParams[0], config );
        for(var i=0; i<response.data.data.length; i++) {
          response.data.data[i].colors = JSON.parse(response.data.data[i].colors);
        }
        console.log("CATALOG RESPONSE2" , response);
        return response.data;
    } catch (error) {
        console.log(error);
    }    
  });

  export const searchCatalog = createAsyncThunk('catalog/searchCatalog', async (search) => {
    try {
      console.log("SEARCH TERMS", search);
      let config = {
          headers: AuthHeader.authHeader(),
          params: {
            searchTerm: search[0],
            range: JSON.stringify([search[1], search[2]])
          },
        }

        const response = await axios.get(process.env.REACT_APP_API_URL + "/catalog/search/all", config );
        for(var i=0; i<response.data.data.length; i++) {
          response.data.data[i].colors = JSON.parse(response.data.data[i].colors);
        }
        return response.data;
    } catch (error) {
        console.log(error);
    }    
  });

  export const getFeatured = createAsyncThunk('catalog/getFeatured', async () => {
    console.log("GET FEATURED");
    try {
        const response = await axios.get(process.env.REACT_APP_API_URL + "/catalog/featured", { headers: AuthHeader.authHeader()});
        if (response.data?.data) {
          for (var i = 0; i < response.data.data.length; i++) {
            if (response.data.data[i].isPrintItem || !response.data.data[i].colors) {
              continue;
            }
            response.data.data[i].colors = JSON.parse(response.data.data[i].colors);
          }
        }
        console.log("CATALOG FEATURED RESPONSE" , response);
        return response.data;
    } catch (error) {
        console.log(error);
        throw error;
    }    
  });

  export const selectAllCatalogItems = state => state.catalog;
  export const selectAllIgniteProducts = state => state.catalog.igniteProducts;
  export const igniteProductsTotalCount = state => state.catalog.igniteProductsTotalCount;
  export const igniteProductsStatus = state => state.catalog.igniteProductsStatus;
  export const allFeatured = state => state.catalog.featured;
  export const selectCatalogItem = state => state.catalog.currentItem;
  export const selectCurrentNewHireKitItems = state => state.catalog.currentNewHireKitItems;
  export const selectDecorations = state => state.catalog.currentDecorations;
  export const selectInventory = state => state.catalog.inventory;
  export const selectOtherCatalogItems = state => state.catalog.otherProducts;
  export const catalogTotalCount = state => state.catalog.catalogTotalCount;
  export const selectStyle = state => state.catalog.style;
  export const selectQuantityPrices = state => state.catalog.quantityPrices;
  export const selectUserCapability = state => state.catalog.userCapability;

  export const getCatalogItem = createAsyncThunk('catalog/getCatalogItem', async (itemId) => {
        const response = await axios.get(process.env.REACT_APP_API_URL + "/catalog/item/" + itemId, { headers: AuthHeader.authHeader()});

        for(var i=0; i<response.data.items.length; i++) {
          response.data.items[i].sizes = JSON.parse(response.data.items[i].sizes);
          response.data.items[i].sizes.sort(function compareFn(a, b) {
            if (a.order < b.order ) {
              return -1;
            }
            if (a.order > b.order) {
              return 1;
            }
            // a must be equal to b
            return 0;
          });
        }
        
        return response.data;
  });

  export const getAdminCatalogItem = createAsyncThunk('catalog/getAdminCatalogItem', async (itemId) => {
        const response = await axios.get(process.env.REACT_APP_API_URL + "/admin/catalog/item/" + itemId, { headers: AuthHeader.authHeader()});
        for(var i=0; i<response.data.item.length; i++) {
          response.data.item[i].sizes = JSON.parse(response.data.item[i].sizes);
          response.data.item[i].sizes.sort(function compareFn(a, b) {
            if (a.order < b.order ) {
              return -1;
            }
            if (a.order > b.order) {
              return 1;
            }
            // a must be equal to b
            return 0;
          });
        }
        return response.data;
  });

  export const getNewHireKitItems = createAsyncThunk('catalog/getNewHireKitItems', async (male) => {
    try {
        // Storefront-readable endpoint (also works for admin NHK order UI)
        const response = await axios.get(process.env.REACT_APP_API_URL + "/newhirekititems/" + male, { headers: AuthHeader.authHeader()});
        for(var i=0; i<response.data.items.length; i++) {
          console.log("SIZES", JSON.parse(response.data.items[i].sizes));
          response.data.items[i].sizes = JSON.parse(response.data.items[i].sizes);
          response.data.items[i].sizes.sort(function compareFn(a, b) {
            if (a.order < b.order ) {
              return -1;
            }
            if (a.order > b.order) {
              return 1;
            }
            // a must be equal to b
            return 0;
          });
        }
        return response.data;
    } catch (error) {
        console.log(error);
    }    
  });

  export const addColor = createAsyncThunk('catalog/addColor', async (productIds) => {
    try {
        const response = await axios.post(process.env.REACT_APP_API_URL + "/admin/catalog/addcolors/", 
        { productIds: productIds },
        { headers: AuthHeader.authHeader()});
        return response.data;
    } catch (error) {
        console.log(error);
    }    
  });

  const initialState = {
    catalog: [],
    igniteProducts: [],
    igniteProductsTotalCount: 0,
    igniteProductsStatus: 'idle',
    catalogTotalCount: 0,
    featured: [],
    currentNewHireKitItems: [],
    currentItem: [],
    currentDecorations: [],
    otherProducts: [],
    status: 'idle',
    featuredStatus: 'idle',
    itemStatus: 'idle',
    adminItemStatus: 'idle',
    adminCatalogStatus: 'idle',
    error: null,
    style: {}

  };

  const catalogSlice = createSlice({
    name: 'catalog',
    initialState,
    reducers: {},
    extraReducers(builder) {
        builder
          .addCase(getCatalog.pending, (state, action) => {
            state.status = 'loading'
          })
          .addCase(getCatalog.fulfilled, (state, action) => {
            state.status = 'succeeded'
            // Add any fetched posts to the array
            console.log("ADD TO CATALOG ARRAY", action.payload.data);
            state.catalog = action.payload.data;
            state.catalogTotalCount = action.payload.count;
            console.log("ADD TO CATALOG ARRAY", state.catalog);

          })
          .addCase(getCatalog.rejected, (state, action) => {
            state.status = 'failed'
            state.error = action.error.message
          })
          .addCase(getIgniteProducts.pending, (state, action) => {
            state.igniteProductsStatus = 'loading'
          })
          .addCase(getIgniteProducts.fulfilled, (state, action) => {
            state.igniteProductsStatus = 'succeeded'
            state.igniteProducts = action.payload?.data || [];
            state.igniteProductsTotalCount = action.payload?.count || 0;
          })
          .addCase(getIgniteProducts.rejected, (state, action) => {
            state.igniteProductsStatus = 'failed'
            state.error = action.error.message
          })
          .addCase(getAdminCatalog.pending, (state, action) => {
            state.adminCatalogStatus = 'loading'
          })
          .addCase(getAdminCatalog.fulfilled, (state, action) => {
            state.adminCatalogStatus = 'succeeded'
            state.catalog = action.payload.data;
            state.catalogTotalCount = action.payload.count;
          })
          .addCase(getAdminCatalog.rejected, (state, action) => {
            state.adminCatalogStatus = 'failed'
            state.error = action.error.message
          })
          .addCase(searchCatalog.pending, (state, action) => {
            state.status = 'loading'
          })
          .addCase(searchCatalog.fulfilled, (state, action) => {
            state.status = 'succeeded'
            // Add any fetched posts to the array
            console.log("ADD TO CATALOG ARRAY", action.payload.data);
            state.catalog = action.payload.data;
            state.catalogTotalCount = action.payload.count;
            console.log("ADD TO CATALOG ARRAY", state.catalog);

          })
          .addCase(searchCatalog.rejected, (state, action) => {
            state.status = 'failed';
            state.error = action.error.message;
          })
          .addCase(getFeatured.pending, (state, action) => {
            state.featuredStatus = 'loading';
          })
          .addCase(getFeatured.fulfilled, (state, action) => {
            state.featuredStatus = 'succeeded';
            console.log("ACTION PAYLOAD", action.payload);
            state.featured = action.payload?.data || [];
          })
          .addCase(getFeatured.rejected, (state, action) => {
            state.featuredStatus = 'failed';
            state.error = action.error.message;
          })
          .addCase(getCatalogItem.pending, (state, action) => {
            state.itemStatus = 'loading';
          })
          .addCase(getCatalogItem.fulfilled, (state, action) => {
            state.itemStatus = 'succeeded';
            // Add any fetched posts to the array
            state.currentItem = action.payload || null;
            state.inventory = action.payload?.inventory;
            state.quantityPrices = action.payload?.quantityPrices || [];
            state.userCapability = action.payload?.userCapability;
          })
          .addCase(getCatalogItem.rejected, (state, action) => {
            state.itemStatus = 'failed';
            state.currentItem = null;
            state.error = action.error.message;
          })
          .addCase(getAdminCatalogItem.pending, (state, action) => {
            state.adminItemStatus = 'loading';
            state.currentItem = [];
          })
          .addCase(getAdminCatalogItem.fulfilled, (state, action) => {
            state.adminItemStatus = 'succeeded';
            // Add any fetched posts to the array
            console.log("ITEM IN REDUCER", action.payload);
            state.currentItem = action.payload?.item || [];
            state.currentDecorations = action.payload?.decorations || [];
            state.otherProducts = action.payload?.otherProducts || [];
            state.inventory = action.payload?.inventory;
            state.style = action.payload?.style || {};
            state.quantityPrices = action.payload?.quantityPrices || [];
          })
          .addCase(getAdminCatalogItem.rejected, (state, action) => {
            state.adminItemStatus = 'failed';
            state.currentItem = [];
            state.error = action.error.message;
          })
          .addCase(getNewHireKitItems.pending, (state, action) => {
            state.adminItemStatus = 'loading';
          })
          .addCase(getNewHireKitItems.fulfilled, (state, action) => {
            state.adminItemStatus = 'succeeded';
            // Add any fetched posts to the array
            console.log("ITEM IN REDUCER", action.payload);
            state.currentNewHireKitItems = {};
            state.currentNewHireKitItems.items = action.payload.items;
            state.inventory = action.payload.inventory;
          })
          .addCase(getNewHireKitItems.rejected, (state, action) => {
            state.adminItemStatus = 'failed';
            state.error = action.error.message;
          })

      }
  });
  
  export default catalogSlice.reducer;


